import { ETRIS02_ARSummary } from "./ETRIS02_ARSummary";



export const ARInquiryReport = {
    "sections": [ETRIS02_ARSummary]
}